module.exports = "/img/_/_/_/assets/images/creeper/book/epic//4.jpg?7fba3fe3536b3d7594bad058c245f631";